import { boxShadows } from '@leafygreen-ui/tokens';

/**
 * Card shadow value for light mode
 * Restores the original Card shadow that was removed in @leafygreen-ui/card v13+
 * Original shadow was: rgba(0, 30, 43, 0.3) 0px 4px 10px -4px
 */
export const cardShadowLight = boxShadows.light[2];

/**
 * Card shadow value for dark mode
 */
export const cardShadowDark = boxShadows.dark[2];

/**
 * Returns the appropriate card shadow based on dark mode setting
 * @param darkMode - Whether dark mode is enabled
 */
export const getCardShadow = (darkMode: boolean): string => {
  return darkMode ? cardShadowDark : cardShadowLight;
};
